module.exports = __webpack_public_path__ + "static/media/moderate.a1014284.png";